<template>
    <transition name="fade">
        <div class="export-tip" v-if="exp.show">
            <!-- 进行中 -->
             <template v-if="exp.status === 'processing'">
                <span class="dot-loading">导出中</span>
                <span class="pct">{{ exp.progress }}%</span>
                <span class="time">{{ exp.timeText }}</span>
                <span class="cancel-btn" @click="handleCancel" v-if="!cancelling">取消</span>
                <span class="cancel-btn disabled" v-else>取消中...</span>
             </template>
             <!-- 完成 -->
             <template v-if="exp.status === 'completed'">
                <span class="done" @click="download">导出完成，点击下载</span>
                <span class="close-btn" @click="close">&times;</span>
             </template>
            <!-- 失败 -->
             <template v-if="exp.status === 'failed'">
                <span class="fail">{{ exp.errorMsg || '导出失败' }}</span>
                <span class="close-btn" @click="close">&times;</span>
             </template>
        </div>
    </transition>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
    name: 'ExportTip',
    data: function() {
        return {
            cancelling: false
        }
    },
    computed: {
        exp: function(){
            return this.$store.state.export;
        }
    },
    watch: {
        'exp.status': function() {
            this.cancelling = false;
        }
    },
    methods: {
        close: function() {
            this.$store.dispatch('export/resetExport');
        },
        download: function() {
            if (this.exp.downloadUrl) {
                window.location.href = this.exp.downloadUrl;
                var self = this;
                setTimeout(function(){
                    self.close();
                }, 500);
            }
        },
        handleCancel: function() {
            var self = this;
            var taskId = this.exp.taskId;
            if (!taskId) {
                this.$message.warning('没有正在进行的导出任务');
                return;
            }

            this.cancelling = true;
            var token = Cookies.get('userToken');
            var cancelUrl = this.$root.commonPreUrl + '/admin/cancelExportTask';

            axios.post(cancelUrl, { task_id: taskId }, {
                headers: { Authorization: 'Bearer ' + token }
            }).then(function(response) {
                if (response.data.code === 200 || response.data.code === '200') {
                    self.$message.success('已取消导出任务');
                    self.$store.dispatch('export/resetExport');
                } else {
                    self.$message.error(response.data.msg || '取消失败');
                    self.cancelling = false;
                }
            }).catch(function(error) {
                console.error('取消导出失败：', error);
                self.$message.error('取消请求失败');
                self.cancelling = false;
            });
        }
    }
}
</script>

<style scoped>
.export-tip {
    position: fixed;
    right: 20px;
    bottom: 20px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 12px;
    color: #333;
    box-shadow: 0 2px 8px rgba(0,0,0,.1);
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 8px;
}
.pct {
    font-weight: bold;
    color: #409eff;
}
.time {
    color: #999;
}
.done {
    color: #67c23a;
    cursor: pointer;
    font-weight: bold;
}
.done:hover {
    text-decoration: underline;
}
.fail {
    color: #f56c6c;
}
.close-btn {
    margin-left: 4px;
    line-height: 1;
    cursor: pointer;
    font-size: 16px;
    color: #999;
}
.close-btn:hover {
    color: #333;
}
.cancel-btn {
    color: #909399;
    cursor: pointer;
    margin-left: 4px;
}
.cancel-btn:hover {
    color: #f56c6c;
}
.cancel-btn.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
}
.dot-loading::after {
    content: '';
    animation: dots 1.5s steps(3, end) infinite;
}
@keyframes dots {
    0% { content: ''; }
    33% { content: '.'; }
    66% { content: '..'; }
    100% { content: '...'; }    
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ExportTip/index.vue